class BrickProductSlider {
  constructor(element) {
    this.element = element;
    this.slides = Array.from(element.querySelectorAll('[data-slide]'));
    this.caption = element.querySelector('[data-slider-caption]');
    this.prev = element.querySelector('[data-slider-prev]');
    this.next = element.querySelector('[data-slider-next]');

    this.index = Math.max(
      0,
      this.slides.findIndex((slide) => slide.classList.contains('is-active'))
    );

    if (this.slides.length <= 1) {
      if (this.prev) this.prev.hidden = true;
      if (this.next) this.next.hidden = true;
      return;
    }

    this.prev?.addEventListener('click', () => {
      this.show(this.index - 1);
    });

    this.next?.addEventListener('click', () => {
      this.show(this.index + 1);
    });

    this.element.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        this.show(this.index - 1);
      }

      if (event.key === 'ArrowRight') {
        this.show(this.index + 1);
      }
    });

    this.show(this.index);
  }

  show(index) {
    if (!this.slides.length) return;

    if (index < 0) {
      index = this.slides.length - 1;
    }

    if (index >= this.slides.length) {
      index = 0;
    }

    this.slides.forEach((slide, slideIndex) => {
      slide.classList.toggle('is-active', slideIndex === index);
    });

    this.index = index;

    const activeSlide = this.slides[index];
    const caption = activeSlide.dataset.caption;

    if (this.caption && caption) {
      this.caption.textContent = caption;
    }
  }
}

function initBrickProductSliders(root = document) {
  root
    .querySelectorAll('[data-brick-product-slider]')
    .forEach((slider) => {
      if (slider.dataset.sliderInitialised === 'true') return;

      slider.dataset.sliderInitialised = 'true';
      slider.setAttribute('tabindex', '0');

      new BrickProductSlider(slider);
    });
}

document.addEventListener('DOMContentLoaded', () => {
  initBrickProductSliders();
});

document.addEventListener('shopify:section:load', (event) => {
  initBrickProductSliders(event.target);
});

document.addEventListener('shopify:block:select', (event) => {
  initBrickProductSliders(event.target);
});